<script setup lang="ts">
const props = defineProps<{
    totalPages: number;
    currentPage: number;
}>()

const emit = defineEmits(['page-changed'])

</script>

<template>
    <nav class="app-pagination">
        <ul class="app-pagination-wrap">
            <li class="app-pagination-item">
                <div
                    class="app-pagination-item-content tx-small cl-second icon-rounded icon-rounded-sm"
                    :class="{ disabled: currentPage === 1, 'cursor-pointer': currentPage !== 1}"
                    aria-label="Previous"
                    @click.prevent="emit('page-changed', currentPage - 1)"
                >
                    <span class="pagination-icon pagination-icon-prev" />
                </div>
            </li>
            <li
                v-for="page in totalPages"
                :key="page"
                class="app-pagination-item cursor-pointer"
                :class="{ active: page === currentPage }"
            >
                <div
                    class="app-pagination-item-content tx-small icon-rounded icon-rounded-sm"
                    :class="{
                        'bg-second text-white': page === currentPage,
                        'cl-second': page !== currentPage,
                       
                    }"
                    @click.prevent="emit('page-changed', page)"
                >
                    {{ page }}
                </div>
            </li>
            <li class="app-pagination-item" :class="{ disabled: currentPage === totalPages, 'cursor-pointer': currentPage !== totalPages}">
                <div class="app-pagination-item-content tx-small cl-second icon-rounded icon-rounded-sm" @click.prevent="emit('page-changed', currentPage + 1)">
                    <span class="pagination-icon pagination-icon-next" />
                </div>
            </li>
        </ul>
    </nav>
</template>

<style scoped lang="scss">
.app-pagination {

    &-wrap {
        display: flex;
        padding-left: 0;
        list-style: none;
        border-radius: 6px;
        justify-content: center;
        margin-bottom: 0;
        flex-wrap: wrap;
    }

    &-item {
        display: flex;

        &-content {
            display: flex;
            align-items: center;
            justify-content: center;
            transition: background-color 0.3s;

            &:hover {
                background: #ECEEF4;
                border-radius: 50%;
                text-decoration: none;
            }
        }
    }
}
</style>


